import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const UploadDocument = forwardRef((props, ref) => {
  const refUploadDoc = useRef();
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadFileName, setUploadFileName] = useState(null);

  const handleDocumentChange = (e) => {
    const file = e.target.files[0];
    setUploadFile(file);
    setUploadFileName(file.name);
  };

  useEffect(() => {
    if (props?.value) {
      setUploadFileName(props?.value);
    }
  }, [props.data]);
  useImperativeHandle(ref, () => {
    return {
      getValue() {
        const rowData = props?.node;
        rowData.setDataValue("file", uploadFile);
        return uploadFileName;
      },
    };
  });
  return (
    <TextField
      variant="outlined"
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <input
              type="file"
              accept=".pdf,.doc,.docx"
              onChange={handleDocumentChange}
              style={{ display: "none" }}
              id="file-input"
            />
            <label htmlFor="file-input">
              <IconButton component="span">
                <CloudUploadIcon color="warning" />
              </IconButton>
            </label>
          </InputAdornment>
        ),
      }}
      value={uploadFileName}
      disabled
      ref={refUploadDoc}
    />
  );
});

export default UploadDocument;
